var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowDesktop = function SvgLeftArrowDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.25,
    fill: "#fff",
    stroke: "#E5EBEE",
    strokeWidth: 1.5,
    transform: "rotate(180 30 30)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0265dc",
    strokeWidth: 3,
    d: "m27.94 38.427-8.629-8.629 8.629-8.628M41.798 29.798H19.136"
  })));
};
export { SvgLeftArrowDesktop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMjkuMjUiIHRyYW5zZm9ybT0icm90YXRlKDE4MCAzMCAzMCkiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNFNUVCRUUiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yNy45Mzk2IDM4LjQyNjlMMTkuMzExIDI5Ljc5ODNMMjcuOTM5NiAyMS4xNjk4IiBzdHJva2U9IiMwMjY1ZGMiIHN0cm9rZS13aWR0aD0iMyIvPgo8cGF0aCBkPSJNNDEuNzk3OSAyOS43OTgzTDE5LjEzNTkgMjkuNzk4MyIgc3Ryb2tlPSIjMDI2NWRjIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==";